import { createFileRoute } from '@tanstack/react-router';
import type React from 'react';
import { LibrarySearchResultsProvider } from 'src/context/LibrarySearchResultsContext';
import { GalleryPage } from 'src/Gallery/GalleryPage';
import { requireAuth } from 'src/utils/authGuard';
import { type GallerySearchParams, gallerySearchSchema } from 'src/utils/searchSchemas';

export type { GallerySearchParams };

const GalleryRoute = (): React.ReactElement => (
  <LibrarySearchResultsProvider>
    <GalleryPage />
  </LibrarySearchResultsProvider>
);

export const Route = createFileRoute('/library/gallery/$galleryId')({
  validateSearch: gallerySearchSchema,
  beforeLoad: () => {
    requireAuth();
  },
  component: GalleryRoute,
});
